<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="execDailyUser(0)"
            >
              당일통계 수행
            </b-button>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="execDailyUser(1)"
            >
              전일통계 수행
            </b-button>
          </b-col>
          <b-col
            v-if="false"
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="execTestFreePassInit()"
            >
              프리패스 연동 초기화
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import { ref, onMounted, getCurrentInstance } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import { errorFormatter } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
  },

  setup() {
    const dateFormatter = value => dayjs(new Date(value)).format('YY-MM-DD')
    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    // Query Data
    // Query Data End.

    // Main Table Config
    const execDailyUser = prevDay => {
      axios.patch(`/fa/common/qa-tools/daily-user/${prevDay}`)
        .then(rs => {
          // TODO : 동작결과 뷰 개선 필요 (ex. QA 전용 로그 테이블에 요청자, 요청동작 등 이력 적재 + 최신 로그 100건 조회 + toast 대신 로그조회 갱신 으로 처리)
          // TODO : 중복 요청 차단처리 필요 (ex. 여러 사용자가 통계 등 큰 요청을 하는 경우 중복된 요청 block)
          toast({
            component: ToastificationContent,
            props: {
              title: '요청 완료',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '오류가 발생하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const execTestFreePassInit = () => {
      // axios.patch(`/fa/common/qa-tools/test-freepass-init`)
      //   .then(rs => {
      //     toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: '요청 완료',
      //         icon: 'CheckCircleIcon',
      //         variant: 'success',
      //       },
      //     })
      //   })
      //   .catch(() => {
      //     toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: '오류가 발생하였습니다.',
      //         icon: 'AlertTriangleIcon',
      //         variant: 'danger',
      //       },
      //     })
      //   })
    }

    return {
      execDailyUser,
      execTestFreePassInit,

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
